import styled from 'styled-components';
import {
  MeetingPagesSidePane,
  RightNavBarWrapper,
  SidePaneHeader,
  SidePaneWrapper,
  SidePaneContent,
} from '../../meeting-pages/side-pane';

const RightPane = styled.div`
  width: 35%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--scarlet-gray-50);
  border-radius: var(--border-radius-small);
  min-height: 0;
  overflow: hidden;

  .trigger-tag-content {
    max-width: 350px;
  }

  ${SidePaneHeader} {
    background-color: var(--scarlet-gray-10);
    border-bottom: 0;
    padding: var(--spacing-05) var(--spacing-06);
  }

  ${SidePaneWrapper} {
    height: 100%;
    width: 100%;
    max-width: 100%;
  }

  ${SidePaneContent} {
    width: 100%;
  }

  ${RightNavBarWrapper} {
    background-color: var(--scarlet-gray-20);

    .active {
      background-color: var(--white);
      border-radius: var(--border-radius-default);
    }
  }
`;

export type DocumentAgentRightPaneProps = {
  items: Array<{
    key: string;
    title: React.ReactNode;
    icon: React.ReactNode;
    content: React.ReactNode;
    disableManualOpen?: boolean;
  }>;
  activeKey?: string;
  onSelect: (key: string) => void;
  onClose: () => void;
  canClose?: boolean;
};

export const DocumentAgentRightPane = ({
  items,
  activeKey,
  onSelect,
  onClose,
  canClose = false,
}: DocumentAgentRightPaneProps) => {
  return (
    <RightPane>
      <MeetingPagesSidePane
        items={items}
        activeKey={activeKey}
        onSelect={onSelect}
        onClose={onClose}
        canClose={canClose}
      />
    </RightPane>
  );
};
